import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Machine } from '../masterdata/models/machine';
import { MessagesService } from '../messages/messages.service';
import { CarrierStatusService } from '../carrier-status/carrier-status.service';
import { ContainerMergeService } from './container-merge.service';
import { SelectableLab } from '../carrier/selectable-lab';
import { MergeRequest } from './merge-request';
import { saveAs as saveByFileSaver } from "file-saver";
import { ErrorHandler } from "../utils/error-handler"
import { BBResponseContainer } from '../carrier/response-container';
import { MergePrintRequest } from './merge-print-request';
import { ProcessState } from '../masterdata/models/processState-enum';
import { CarrierState } from '../masterdata/models/carrierState';
import { ContainerType } from '../container-view/models/container-type-enum';
import { Printer } from '../masterdata/models/printer';
import { ConfirmationService } from 'primeng/api';
import { EchoFileRequest } from './echo-file-request';

@Component({
  selector: 'app-container-merge',
  templateUrl: './container-merge.component.html',
  styleUrls: ['./container-merge.component.css']
})
export class ContainerMergeComponent implements OnInit {

  containerMergeForm: FormGroup;
  errorHandler: ErrorHandler = new ErrorHandler;

  selectedLab: SelectableLab;
  machineList: Machine[];
  machineBarcode: string;
  c1Barcode: string;
  c2Barcode: string;
  c3Barcode: string;
  c4Barcode: string;
  createdBy: string
  targetBarcode: string;
  isReadyForSubmit: boolean;
  outputContainer: string;
  response: BBResponseContainer;
  startMergeRequst: MergeRequest;
  blocked:boolean;
  genRequst: MergeRequest;

  mergePrintRequest: MergePrintRequest;
  mergePrintBarcode: string;
  labID: string;
  selectedPlateType: ContainerType;
  selectedPrinter: Printer;
  echoFileRequest:EchoFileRequest;

  @Input() carrierStateDetails: CarrierState;
  @Input() printersList: Printer[];
 
  constructor(private formBuilder: FormBuilder, private carrierStatusService: CarrierStatusService,
    private _messagesService: MessagesService, private containerMergeService: ContainerMergeService,
    private confirmationService: ConfirmationService) {
    this.selectedLab = JSON.parse(localStorage.getItem('lab'));
    this.selectedPlateType = ContainerType.REACTIONPLATE;
  }

  ngOnInit() {
    // printer selected in process step in mdm is selected by default
    if (this.carrierStateDetails.printer && this.carrierStateDetails.printer.active) {
      this.selectedPrinter = this.carrierStateDetails.printer;
    }

    this.carrierStatusService.getMachineList().subscribe(
      results => {
        this.machineList = results.data;
      })

    this.containerMergeForm = this.formBuilder.group({
      'A1': new FormControl('', Validators.required),
      'A2': new FormControl('', ),
      'B1': new FormControl('', ),
      'B2': new FormControl('', ),
      'plateTypeSelector': ['Reaction Plate', []],
      'createdBy': new FormControl('', Validators.required),
      'machineBarcode': new FormControl('', Validators.required),
      'targetContainer': new FormControl('', Validators.required),
      'mergeSelectedPrinter': new FormControl('', Validators.required)
    });
  }

  generatePrintBarcode(){
    this.blocked = true;
    let isWarned: boolean;
    let isPremixWarned: boolean;
    var inputBarcodes: string[];
      if (!this.c2Barcode) {
        this.c2Barcode = "";
      }
      if (!this.c3Barcode) {
        this.c3Barcode = "";
      }
      if (!this.c4Barcode) {
        this.c4Barcode = "";
      }
      inputBarcodes = [this.c1Barcode.trim(), this.c2Barcode.trim(), this.c3Barcode.trim(), this.c4Barcode.trim()];

      if (!this.machineBarcode) {
        this.machineBarcode = "";
      }

      if (!this.targetBarcode) {
        this.targetBarcode = "";
      }

      this.genRequst = {
        lab: this.selectedLab.lab,
        inputBarcodes: inputBarcodes,
        createdBy: this.createdBy,
        machineBarcode: this.machineBarcode.trim(),
        targetBarcode: this.targetBarcode.trim(),
        processState: ProcessState.STARTED,
        machineType: this.carrierStateDetails.machineType,
        containerType: this.selectedPlateType,
        warned: isWarned,
        premixWarned:isPremixWarned
      };
      this.containerMergeService.generatePrintBarcodes(this.genRequst).subscribe(
        results => {
          this.blocked=false;
          this.targetBarcode = results.data;
          console.log("target barcode is:" + this.targetBarcode);
          this.mergePrintRequest = {
            lab: this.selectedLab.lab,
            inputBarcode: this.c1Barcode,
            printBarcodeType: this.targetBarcode,
            printer: this.selectedPrinter
          };
          this.containerMergeService.printBarcode(this.mergePrintRequest).subscribe(
            internalResults => {
              this.blocked=false;
              if (!internalResults) {
                return;
              }
              if (internalResults.data == true)
                this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Print successful', detail: 'Barcode printed successfully' });
              else
                this._messagesService.addErrorMessage({ severity: 'error', summary: 'Failed', detail: "Barcode print failed" });

            },
            error => {
              this.blocked=false;
              let message = this.errorHandler.handleError(error);
              this._messagesService.addErrorMessage(message);
            }
          )
        },
        error => {
          this.blocked=false;
          console.log(error);
          let message = this.errorHandler.handleError(error);
          console.log("error msg : " + message.detail);
          this._messagesService.addErrorMessage(message);
        }
      );
  }

  startMergingContainers() {
    this.blocked = true;
  let isWarned: boolean;
  let isPremixWarned:boolean;
  var inputBarcodes: string[];
    if (!this.c2Barcode) {
      this.c2Barcode = "";
    }
    if (!this.c3Barcode) {
      this.c3Barcode = "";
    }
    if (!this.c4Barcode) {
      this.c4Barcode = "";
    }
    inputBarcodes = [this.c1Barcode.trim(), this.c2Barcode.trim(), this.c3Barcode.trim(), this.c4Barcode.trim()];

    this.startMergeRequst = {
      lab: this.selectedLab.lab,
      inputBarcodes: inputBarcodes,
      createdBy: this.createdBy,
      machineBarcode: this.machineBarcode.trim(),
      targetBarcode: this.targetBarcode.trim(),
      processState: ProcessState.STARTED,
      machineType: this.carrierStateDetails.machineType,
      containerType: this.selectedPlateType,
      warned: isWarned,
      premixWarned:isPremixWarned
    };

    this.containerMergeService.startMergingContainers(this.startMergeRequst).subscribe(
      results => {
        if(results.bbApiWarning){
          this.blocked = false;
          if(results.bbApiWarning.title.includes("premix")){
            this.confirmationService.confirm({
              message: 'Are you sure that you want to proceed?',
              header: results.bbApiWarning.title,
              icon: 'pi pi-exclamation-triangle',
              accept: () => {
                this.blocked=true;
                isPremixWarned = true;
                this.startMergeRequst.premixWarned = isPremixWarned;
                this.containerMergeService.startMergingContainers(this.startMergeRequst).subscribe(
                  internalResults => {
                    this.blocked=false;
                    this.outputContainer = internalResults.data;
                    this._messagesService.addSuccessMessage({ severity: 'success', summary: 'process Started', detail: 'Started Merging of Containers.. ' });
                  });
              },
              reject: () => {
                this.blocked=false;
                isPremixWarned = false;
                this.startMergeRequst.premixWarned = isPremixWarned;
                this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Merging stopped', detail: 'Did not choose to continue merging premix plates to storage plate' });
              }
          });
          }else{
            console.log("containers got both purified and unpurified material");
            this.confirmationService.confirm({
              message: 'Are you sure that you want to proceed?',
              header: 'Containers got both purified and unpurified material',
              icon: 'pi pi-exclamation-triangle',
              accept: () => {
                this.blocked=true;
                isWarned = true;
                this.startMergeRequst.warned = isWarned;
                this.containerMergeService.startMergingContainers(this.startMergeRequst).subscribe(
                  internalResults => {
                    this.blocked=false;
                    this.outputContainer = internalResults.data;
                    this._messagesService.addSuccessMessage({ severity: 'success', summary: 'process Started', detail: 'Started Merging of Containers.. ' });
                  });
              },
              reject: () => {
                this.blocked=false;
                isWarned = false;
                this.startMergeRequst.warned = isWarned;
                this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Merging stopped', detail: 'Did not choose to continue merging purified and unpurified plates' });
              }
          });
        }

      }else{
        this.blocked=false;
        this.outputContainer = results.data;
        console.log("output container is:" + results.data);
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'process Started', detail: 'Started Merging of Containers.. ' });
      }
      },
      error => {
        this.blocked=false;
        console.log(error);
        let errMessage = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(errMessage);
      });
  }

  completeMergingContainers() {
    var inputBarcodes: string[];
    if (!this.c2Barcode) {
      this.c2Barcode = "";
    }
    if (!this.c3Barcode) {
      this.c3Barcode = "";
    }
    if (!this.c4Barcode) {
      this.c4Barcode = "";
    }
    inputBarcodes = [this.c1Barcode.trim(), this.c2Barcode.trim(), this.c3Barcode.trim(), this.c4Barcode.trim()];

    let completeMergeRequst = { lab: this.selectedLab.lab, inputBarcodes: inputBarcodes, createdBy: this.createdBy, machineBarcode: this.machineBarcode.trim(), targetBarcode: this.targetBarcode.trim(), processState: ProcessState.COMPLETED, machineType: this.carrierStateDetails.machineType, containerType: this.selectedPlateType, warned:false,premixWarned:false };

    this.containerMergeService.completeMergingContainers(completeMergeRequst).subscribe(
      results => {
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'process completed', detail: 'Merging of Containers is Completed ' });
        this.selectedPlateType = ContainerType.REACTIONPLATE;
      },
      error => {
        console.log(error);
        let errMessage = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(errMessage);
      }
    );
    this.outputContainer = null;
    this.startMergeRequst = null;
    this.isReadyForSubmit = true;
  }

  downloadHamiltonFile() {
    if (!this.outputContainer) {
      this._messagesService.addSuccessMessage({ severity: 'warning', summary: 'Not Generated', detail: 'File is not generated' });
      return;
    }
    console.log("Container is:" + this.outputContainer);
    this.containerMergeService.generateHamiltonFile(this.startMergeRequst).subscribe(
      blob => {
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = this.outputContainer + '.xls';
        link.click();
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Downloaded successful', detail: 'Downloaded Hamilton Control file' });
      },
      error => {
        console.log(error);
        let errMessage = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(errMessage);
      });
  }

  downloadEchoFile() {
    if (!this.outputContainer) {
      this._messagesService.addSuccessMessage({ severity: 'warning', summary: 'Not Generated', detail: 'File is not generated' });
      return;
    }
    this.echoFileRequest = new EchoFileRequest();
    this.echoFileRequest.containerBarcode = this.outputContainer.trim();
    this.echoFileRequest.labId = this.selectedLab.lab._id;
    this.containerMergeService.generateEchoFile(this.echoFileRequest).subscribe(
      result => {
        if (!result) {
          return;
        }
        let controllerFileContent = result.echoControllerFileContent;
        let blob: Blob = new Blob([controllerFileContent], { type: 'text/plain' });
        let fileName: string = result.data.barcode + '.csv';
        saveByFileSaver(blob, fileName);
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Downloaded successful', detail: 'Downloaded Echo Control file' });
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  /**
   * @function
   * @description: This method is to clear fileds after submit
   */
  onSubmit(value: string) {
    if (this.isReadyForSubmit) {
      this.containerMergeForm.reset();
      document.getElementById('A1').focus();
      this.isReadyForSubmit = false;
    }
  }

  onPlateTypeSelection() {

  }
  /**
   * function to enable Print button for MIX barcode
   */
  printMixEnabled(): boolean {
    if (this.selectedPlateType == ContainerType.CARRIER &&
      (this.c1Barcode || this.c2Barcode || this.c3Barcode || this.c4Barcode)) {
      return true;
    }
    return false;
  }
  /**
   * function to enable Print button for Reaction barcode
   */
  printReactionEnabled(): boolean {
    if (this.selectedPlateType == ContainerType.REACTIONPLATE &&
      (this.c1Barcode || this.c2Barcode || this.c3Barcode || this.c4Barcode)) {
      return true;
    }
    return false;
  }

  enableBarcodeGeneration():boolean{
    if (this.c1Barcode) {
      return true;
    }
    return false;
  }

  /**
   * @function
   * @description: This method is to avoid default submit
   */
  disableDefaultSubmit(event) {
    event.preventDefault();
    event.target.blur();
  }

  /**
   * @function
   * @description: This method is to get the focus to A2 Field
   */
  focusA2() {
    document.getElementById('A2').focus();
  }

  /**
   * @function
   * @description: This method is to get the focus to B1 Field
   */
  focusB1() {
    document.getElementById('B1').focus();
  }


  /**
   * @function
   * @description: This method is to get the focus to B Field
   */
  focusB2() {
    document.getElementById('B2').focus();
  }

  /**
   * @function
   * @description: This method is to get the focus to PUID Field
   */
  focusCreatedBy() {
    document.getElementById('createdBy').focus();
  }

  /**
   * @function
   * @description: This method is to get the focus to Machine Field
   */
  focusMachineBarcode() {
    document.getElementById('machineBarcode').focus();
  }

  /**
   * @function
   * @description: This method is to get the focus to targetContainer Field
   */
  focusTargetContainer() {
    document.getElementById('targetContainer').focus();
  }

  /**
   * @function
   * @description:
   *
  */
  printBarcode(printType) {
    if (this.c1Barcode != undefined && this.c1Barcode != null && this.c1Barcode != "") {
      this.c1Barcode = this.c1Barcode.trim();
      // allow the orderId with length of minmum 4 characters

      console.log("c1Barcode : " + this.c1Barcode);
      console.log("printType : " + printType);

      this.mergePrintRequest = {
        lab: this.selectedLab.lab,
        inputBarcode: this.c1Barcode,
        printBarcodeType: printType,
        printer: this.selectedPrinter
      };

      this.containerMergeService.printBarcode(this.mergePrintRequest).subscribe(
        results => {
          if (!results) {
            return;
          }
          console.log("Is mergePrint Barcode :", results.data);
          //this.mergePrintBarcode = results.data;
          if (results.data == true)
            this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Print successful', detail: 'Barcode printed successfully' });
          else
            this._messagesService.addErrorMessage({ severity: 'error', summary: 'Failed', detail: "Barcode print failed" });

        },
        error => {
          console.log(error);
          let message = this.errorHandler.handleError(error);
          console.log("error msg : " + message.detail);
          this._messagesService.addErrorMessage(message);
        }
      )
    }
  }
}
